import React from 'react';
import styled from 'styled-components';

const Bar = styled.div`
  width: 100%;
  background-color: #E30000; /* example bright purple shade */
  color: #ffffff; /* dark maroon text */
  text-align: center;
  padding: 0.5rem;
  font-size: 1rem;
  font-family: "Roboto Flex", sans-serif;
//   position: fixed;
  z-index: 100;
`;

function OfferBar() {
  return (
    <Bar>
      LIMITED TIME ONLY: Get any custom diamond ring with up to 2.5ct diamonds 
      for a fixed price of £1839. Complementary travel ring included. Only 20% deposit required! T&Cs apply
    </Bar>
  );
}

export default OfferBar;
